// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

/* export const environment = {
    production: false,
    version: '2.1.58',
    comunEndpoint: 'https://int.ms-comun.digo.tecalis.dev/',
    amenaEndpoint: 'https://int.ms-amena.digo.tecalis.dev/',
    rmEndpoint: 'https://int.ms-repmovil.digo.tecalis.dev/',
    simyoEndPoint: 'https://int.ms-simyo.digo.tecalis.dev/',
    orangeEndPoint: 'https://int.ms-orange.digo.tecalis.dev/',
    oldDigoEndPoint: 'https://int-b.dev.tecalis.com/',
    digoEndPoint: 'https://int.digo.tecalis.dev/',
    masmovilEndpoint: 'https://ms-masmovil.lamarr.digo.tecalis.dev',
    digoApiKey: 'theyUJu3tes@efaswejahEZ@afR5Fenu',
    googleMapsCountry: 'es',
    showRM: true,
    showSimyoTerminals: true,
    piloto: 'piloto_pdv',
    showSkipKYC: true,
    enableMyAddress : true,
    contractNewBrands: 'https://agents.masstack.com/',
    contractPepephone: 'https://canales.pepephone.com/',
}; */

export const environment = {
    production: false,
    version: '2.1.58',
    comunEndpoint: 'https://int.ms-comun.digo.tecalis.dev/',
    amenaEndpoint: 'https://ms-amena.lamarr.digo.tecalis.dev/',
    rmEndpoint: 'https://ms-repmovil.lamarr.digo.tecalis.dev/',
    simyoEndPoint: 'https://int.ms-simyo.digo.tecalis.dev/',
    orangeEndPoint: 'https://int.ms-orange.digo.tecalis.dev/',
    oldDigoEndPoint: 'https://int-b.dev.tecalis.com/',
    digoEndPoint: 'https://int-b.dev.tecalis.com/digo/current/',
    masmovilEndpoint: 'https://api.tecalis.com/dev/digo/ms-masmovil-int',
    simyoParadigmaEndpoint: 'https://api.tecalis.com/digo/ms-web',
    digoApiKey: 'theyUJu3tes@efaswejahEZ@afR5Fenu',
    googleMapsCountry: 'es',
    showRM: true,
    showSimyoTerminals: true,
    piloto: 'piloto_pdv',
    showSkipKYC: true,
    enableMyAddress : true,
    contractNewBrands: 'https://agents.masstack.com/',
    contractPepephone: 'https://canales.pepephone.com/',
    msDigoApp: "https://int.ms-digo-app.digo.tecalis.dev/",
    firebase: {
        apiKey: "AIzaSyDY44UvRg1_3HW0CP2PziDsMYQ7A3Y4MzM",
        authDomain: "digoapp-64a2a.firebaseapp.com",
        databaseURL: "https://digoapp-64a2a-default-rtdb.europe-west1.firebasedatabase.app",
        projectId: "digoapp-64a2a",
        storageBucket: "digoapp-64a2a.firebasestorage.app",
        messagingSenderId: "744374205219",
        appId: "1:744374205219:web:862862830be8b8c65daa96",
        measurementId: "G-SWJ8JRWZ0R",
        firestoreDatabase: "integration"
    },
    domainMigration: {
        username: 'demo_pdv',
        sourceHostname: 'digo.dexga.com',
        targetHostname: 'digo.tecalis.com',
    },
};

// Cuando se añada una url de un micro a environment, hacer referencia a ella también en esta constante
// Este array de urls son utilizadas por el interceptor.
export const microserviceUrls = [
    environment.comunEndpoint,
    environment.amenaEndpoint,
    environment.rmEndpoint,
    environment.simyoEndPoint,
    environment.orangeEndPoint,
    // environment.oldDigoEndPoint,
    environment.digoEndPoint,
    environment.masmovilEndpoint,
    environment.simyoParadigmaEndpoint,
    environment.msDigoApp
];

export const iaAssistantLink = 'https://cia-commercial-offer-chatbot.prod.k8s.masmovil.com/';

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
